import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/home/HomePage'
import SearchResults from '@/components/search-results/SearchResultsPage'
import EditorialBoardMembers from '@/components/editorial-board/EditorialBoardMembersPage'
import AuthorDetailsComponent from '@/components/shared/AuthorDetailsComponent'
import HundredPlus from '@/components/editorial-board/HundredPlusPapersPage'
import IssueDetail from '@/components/publications/IssueDetailPage'
import AdvanceOnlinePublications from '@/components/publications/AdvanceOnlinePublicationsPage'

import ArticlePage from '@/components/publications/article-detail/ArticlePage'
import ArticleDetail from '@/components/publications/article-detail/ArticleDetailPage'
import Authors from '@/components/publications/article-detail/AuthorsPage'
import RelatedArticles from '@/components/publications/article-detail/RelatedArticlesPage'
import ArticleData from '@/components/publications/article-detail/ArticleDataPage'
import Metrics from '@/components/publications/article-detail/MetricsPage'
import Geographics from '@/components/publications/article-detail/GeographicsPage'
import Demographics from '@/components/publications/article-detail/DemographicsPage'
import Interact from '@/components/publications/article-detail/InteractPage'
import InteractTables from '@/components/publications/article-detail/InteractTablesPage'
import InteractFigures from '@/components/publications/article-detail/InteractFiguresPage'
import InteractVideo from '@/components/publications/article-detail/InteractVideoPage'
import InteractTrivia from '@/components/publications/article-detail/InteractTriviaPage'
import Media from '@/components/publications/article-detail/MediaPage'
import MediaNews from '@/components/publications/article-detail/MediaNewsPage'
import MediaTwitter from '@/components/publications/article-detail/MediaTwitterPage'
import MediaFacebook from '@/components/publications/article-detail/MediaFacebookPage'
import MediaYouTube from '@/components/publications/article-detail/MediaYoutubePage'
import MediaLinkedIn from '@/components/publications/article-detail/MediaLinkedInPage'
import MediaGoogle from '@/components/publications/article-detail/MediaGooglePage'

import ArchivedIssues from '@/components/publications/ArchivedIssuesPage'
import Collections from '@/components/publications/CollectionsPage'
import CollectionDetail from '@/components/publications/CollectionDetailPage'
import Videos from '@/components/publications/VideosPage'
import AuthorInterviews from '@/components/publications/AuthorInterviewsPage'
import ForAuthors from '@/components/for-authors/ForAuthorsPage'
import ForAuthorsPolicies from '@/components/for-authors/for-authors-policies/ForAuthorsPoliciesPage'
import ForAuthorsSubmission from '@/components/for-authors/for-authors-submission/ForAuthorsSubmissionPage'
import ForAuthorsStyleGuide from '@/components/for-authors/for-authors-style-guide/ForAutorsStyleGuidePage'
import Announcements from '@/components/about/AnnouncementsPage'
import History from '@/components/about/HistoryPage'
import EthicsAndMalpractice from '@/components/about/EthicsAndMalpracticePage'
import AimsAndScope from '@/components/about/AimsAndScopePage'
import Employees from '@/components/about/EmployeesPage'
import Careers from '@/components/about/CareersPage'
import Contact from '@/components/about/ContactPage'
import SponsorshipRequest from '@/components/about/SponsorshipRequestPage'
import StyleGuide from '@/components/StyleGuidePage'
import NotFound from '@/components/NotFoundPage'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/editorial-board-members/',
      name: 'editorialBoardMembers',
      meta: { breadcrumbObject: {'Editorial Board': ''} },
      component: EditorialBoardMembers
    },
    {
      path: '/editorial-board-members/:id',
      name: 'editorialBoardMemberDetail',
      meta: { breadcrumbObject: {'Editorial Board': ''} },
      component: AuthorDetailsComponent
    },
    {
      path: '/search-results/:request',
      name: 'searchResults',
      component: SearchResults,
      meta: { filterIsAvailable: true },
      beforeEnter: (to, from, next) => {
        to.meta['breadcrumbObject'] = {
          'Publications': '',
          'Search': {name: 'searchResults'},
          [`searched for: ${to.params['request']} `]: ''
        }
        next()
      }
    },
    {
      path: '/100-plus-papers',
      name: 'hundredPlus',
      meta: {
        filterIsAvailable: true,
        breadcrumbObject: {
          'Editorial Board': ''
        }
      },
      component: HundredPlus
    },
    {
      path: 'current-issue',
      name: 'currentIssue',
      meta: { breadcrumbObject: {'Publications': ''} },
      component: IssueDetail
    },
    {
      path: '/issue/volume/:volumeId/number/:issueId',
      name: 'issueDetail',
      component: IssueDetail,
      beforeEnter: (to, from, next) => {
        to.meta['breadcrumbObject'] = {
          'Publications': ''
        }
        next()
      }
    },
    {
      path: '/advance-online-publications',
      name: 'advanceOnlinePublications',
      meta: { filterIsAvailable: true },
      component: AdvanceOnlinePublications,
      beforeEnter: (to, from, next) => {
        to.meta['breadcrumbObject'] = {
          'Publications': ''
        }
        next()
      }
    },
    {
      path: '/article/pii/:pii',
      name: 'article-page',
      component: ArticlePage,
      children: [
        {
          path: 'detail',
          name: 'article-detail',
          component: ArticleDetail,
          beforeEnter: (to, from, next) => {
            to.meta['breadcrumbObject'] = {
              'Publications': ''
            }
            next()
          }
        },
        {
          path: 'detail-authors',
          name: 'article-detail-authors',
          component: Authors,
          beforeEnter: (to, from, next) => {
            to.meta['breadcrumbObject'] = {
              'Publications': ''
            }
            next()
          }
        },
        {
          path: 'detail-related',
          name: 'article-detail-related',
          component: RelatedArticles,
          beforeEnter: (to, from, next) => {
            to.meta['breadcrumbObject'] = {
              'Publications': ''
            }
            next()
          }
        },
        {
          path: 'detail-data',
          name: 'article-data',
          component: ArticleData,
          beforeEnter: (to, from, next) => {
            to.meta['breadcrumbObject'] = {
              'Publications': ''
            }
            next()
          }
        },
        {
          path: 'metrics',
          name: 'article-metrics',
          component: Metrics,
          beforeEnter: (to, from, next) => {
            to.meta['breadcrumbObject'] = {
              'Publications': ''
            }
            next()
          }
        },
        {
          path: 'geographics',
          name: 'article-metrics-geographics',
          component: Geographics
        },
        {
          path: 'demographics',
          name: 'article-metrics-demographics',
          component: Demographics
        },
        {
          path: 'interact',
          name: 'article-interact',
          component: Interact
        },
        {
          path: 'tables',
          name: 'article-interact-tables',
          component: InteractTables
        },
        {
          path: 'figures',
          name: 'article-interact-figures',
          component: InteractFigures
        },
        {
          path: 'video',
          name: 'article-interact-video',
          component: InteractVideo
        },
        {
          path: 'trivia',
          name: 'article-interact-trivia',
          component: InteractTrivia
        },
        {
          path: 'media',
          name: 'article-media',
          component: Media
        },
        {
          path: 'news',
          name: 'article-media-news',
          component: MediaNews
        },
        {
          path: 'twitter',
          name: 'article-media-twitter',
          component: MediaTwitter
        },
        {
          path: 'facebook',
          name: 'article-media-facebook',
          component: MediaFacebook
        },
        {
          path: 'youtube',
          name: 'article-media-youtube',
          component: MediaYouTube
        },
        {
          path: 'linkedin',
          name: 'article-media-linkedin',
          component: MediaLinkedIn
        },
        {
          path: 'google',
          name: 'article-media-google',
          component: MediaGoogle
        }
      ]
    },
    {
      path: '/archived-issues',
      name: 'archivedIssues',
      beforeEnter: (to, from, next) => {
        to.meta['breadcrumbObject'] = {
          'Publications': ''
        }
        next()
      },
      component: ArchivedIssues
    },
    {
      path: '/collections',
      name: 'collections',
      beforeEnter: (to, from, next) => {
        to.meta['breadcrumbObject'] = {
          'Publications': ''
        }
        next()
      },
      component: Collections
    },
    {
      path: '/collections/:id',
      name: 'collectionDetail',
      meta: {
        filterIsAvailable: true,
        breadcrumbObject: {
          'Publications': '',
          'Collections': {name: 'collections'}
        }
      },
      component: CollectionDetail
    },
    {
      path: '/videos',
      name: 'videos',
      beforeEnter: (to, from, next) => {
        to.meta['breadcrumbObject'] = {
          'Publications': ''
        }
        next()
      },
      component: Videos
    },
    {
      path: '/author-interviews',
      name: 'authorInterviews',
      beforeEnter: (to, from, next) => {
        to.meta['breadcrumbObject'] = {
          'Publications': ''
        }
        next()
      },
      component: AuthorInterviews
    },
    {
      path: '/for-authors',
      name: 'forAuthors',
      component: ForAuthors,
      children: [
        {
          path: 'policies',
          name: 'forAuthorsPolicies',
          meta: { breadcrumbObject: {'For Authors': ''} },
          component: ForAuthorsPolicies
        },
        {
          path: 'submission-guidelines',
          name: 'forAuthorsSubmissionGuidelines',
          meta: { breadcrumbObject: {'For Authors': ''} },
          component: ForAuthorsSubmission
        },
        {
          path: 'style-guidelines',
          name: 'forAuthorsStyleGuidelines',
          meta: { breadcrumbObject: {'For Authors': ''} },
          component: ForAuthorsStyleGuide
        }
      ]
    },
    {
      path: '/announcements',
      name: 'announcements',
      meta: { breadcrumbObject: {'About': ''} },
      component: Announcements
    },
    {
      path: '/history',
      name: 'history',
      meta: { breadcrumbObject: {'About': ''} },
      component: History
    },
    {
      path: '/aims-and-scope',
      name: 'aimsAndScope',
      meta: { breadcrumbObject: {'About': ''} },
      component: AimsAndScope
    },
    {
      path: '/employees',
      name: 'employees',
      meta: { breadcrumbObject: {'About': ''} },
      component: Employees
    },
    {
      path: '/aims-and-scope',
      name: 'ethicsAndMalpractice',
      meta: { breadcrumbObject: {'About': ''} },
      component: EthicsAndMalpractice
    },
    {
      path: '/careers',
      name: 'careers',
      meta: { breadcrumbObject: {'About/': ''} },
      component: Careers
    },
    {
      path: '/contact',
      name: 'contact',
      meta: { breadcrumbObject: {'About/': ''} },
      component: Contact
    },
    {
      path: '/sponsorship-request',
      name: 'sponsorshipRequest',
      meta: { breadcrumbObject: {'About/': ''} },
      component: SponsorshipRequest
    },
    {
      path: '/style-guide',
      name: 'styleGuide',
      component: StyleGuide
    },
    //  This route must stay at the end - order matters!
    { path: '*',
      component: NotFound
    }
  ]
})

router.afterEach((to, from) => {
  let collapseNav = document.getElementById('nav_collapse')
  if (collapseNav && collapseNav.classList.contains('show')) {
    router.app.$emit('collapse::toggle', 'nav_collapse')
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js